import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';
import useCustomers from '@/features/party/queries/hooks/useCustomers';
import useAuth from '@/hooks/useAuth';
import useInviteUser from '@/mutations/useInviteUser';

export default function useMyEnvironment() {
  const party = useSelectedParty();

  const { broker, isBrokerLoading } = useAuth();

  const hasAccess = broker?.modules_v2?.['customerportal']?.status === 'ACTIVE';

  const { data: customers, isLoading: isCustomersLoading } = useCustomers(
    party?.id ?? '',
    undefined,
    { enabled: Boolean(party?.id) },
  );

  const isLoading = isBrokerLoading || isCustomersLoading;

  const { mutateAsync: inviteUser } = useInviteUser();

  return {
    customers,
    isLoading,
    hasAccess,
    inviteUser,
  };
}
